import React, { Component } from 'react';
import Moment from 'react-moment';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import 'moment/locale/pt-br';

import { ListItem, Button, Details } from './styles';
import spacer from '../../../../assets/images/spacer.png';

Moment.globalLocale = 'pt-br';

class Item extends Component {
  onPress = () => {
    this.props.onPressItem(this.props.id);
  };

  render() {
    const {
      date,
      total,
      balance,
      tax,
      orders,
    } = this.props.item;

    return (
      <div>
        <ListItem selected={this.props.selected}>
          <div className="row">
            <h2>Data</h2>
            <Moment className="date" format="MMMM YYYY">{date}</Moment>
          </div>
          <div className="row">
            <h2>Valor total</h2>
            <p>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(total)}</p>
          </div>
          <div className="row">
            <h2>Valor recebido</h2>
            <p>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(balance)}</p>
          </div>
          <div className="row last-row">
            <h2>Remuneração</h2>
            <p>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(tax)}</p>
          </div>
          <Button type="submit" onClick={this.onPress}>
            <span>Detalhes</span>
            {!this.props.selected && <FaAngleDown className="fa fa-angle-down" />}
            {this.props.selected && <FaAngleUp className="fa fa-angle-up" />}
          </Button>
        </ListItem>
        <Details selected={this.props.selected}>
          <img src={spacer} alt="" className="spacer" />
          <div className="container">
            <div className="row">
              <p>
                <span>Pedidos recebidos:</span>
                {orders.received}
              </p>
            </div>
            <div className="row">
              <p>
                <span>Pedidos entregues:</span>
                {orders.delivered}
              </p>
            </div>
          </div>
        </Details>
      </div>
    );
  }
}

export default Item;
